export default "__VITE_ASSET__HRnsam_x__"